<template>
  <transition name="spin-fade" appear @after-leave="afterLeave">
    <div
      v-show="visible"
      class="spin-wrapper"
      :style="{ backgroundColor: background, zIndex }"
    >
      <span class="spin" :class="size">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </span>
      <span v-if="description" class="desc" :class="size">{{ description }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    /** 显隐 */
    visible: {
      type: Boolean,
      default: false
    },
    /** 离开动画结束后的回调 */
    afterLeave: {
      type: Function,
      default: () => {}
    },
    /** 尺寸 */
    size: {
      type: String
    },
    /** 文字描述 */
    description: {
      type: String
    },
    /** 背景色 */
    background: {
      type: String
    },
    /** 层级 */
    zIndex: {
      type: String,
      default: '100'
    }
  }
};
</script>

<style>
.spin-parent {
  position: relative !important;
  pointer-events: none !important;
}
</style>

<style lang="scss" scoped>
.spin-fade-enter-active,
.spin-fade-leave-active {
  transition: opacity 0.3s;
}
.spin-fade-enter,
.spin-fade-leave-to {
  opacity: 0;
}

.spin-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 100;
}

.spin {
  width: 1em;
  height: 1em;
  font-size: 20px;
  position: relative;
  display: inline-block;
  transform: rotate(45deg);
  animation: Spin 1.2s infinite linear;
  &.small {
    font-size: 14px;
    i {
      width: 6px;
      height: 6px;
    }
  }
  &.large {
    font-size: 32px;
    i {
      width: 14px;

      height: 14px;
    }
  }
  i {
    position: absolute;
    display: block;
    width: 9px;
    height: 9px;
    background-color: $color-primary;
    border-radius: 100%;
    opacity: 0.3;
    transform: scale(0.75);
    animation: SpinMove 1s infinite linear alternate;
    &:nth-child(1) {
      top: 0;
      left: 0;
    }
    &:nth-child(2) {
      top: 0;
      right: 0;
      animation-delay: 0.4s;
    }
    &:nth-child(3) {
      right: 0;
      bottom: 0;
      animation-delay: 0.8s;
    }
    &:nth-child(4) {
      bottom: 0;
      left: 0;
      animation-delay: 1.2s;
    }
  }
}

.desc {
  color: $color-primary;
  padding-top: 10px;
  font-size: 14px;
  &.small {
    font-size: 12px;
  }
}

@keyframes Spin {
  to {
    transform: rotate(405deg);
  }
}

@keyframes SpinMove {
  to {
    opacity: 1;
  }
}
</style>
